<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      details: "", //是否是详情。
      videoinfo: {}, //考试的信息详情
      title:'', // 视频名称
      indexState: "", // 判断是添加还是编辑还是详情
      videoid: "",
      surplus: "", // 视频剩余容量
      newState : 0, // 0原路返回 1特殊返回
    };
  },
  components: {
    CertifiedHosp: () => import("./page.vue"),
    isedit: () => import("./components/index.vue"),
    studySituation: () => import("./studySituation.vue"),
    study: () => import("./study.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "isedit";
        case 2:
          return "studySituation";
        case 3:
          return "study";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (this.indexState == 0 && this.isActive == "1") {
        // 新增
        this.$children[0].Buriedpoint({
          code: "Resource:Videoresources:upload",
          parent_code: "Resource:Videoresources",
        });
      } else if (this.indexState == 1 && this.isActive == "1") {
        // 编辑
        this.$children[0].Buriedpoint({
          code: "Resource:Videoresources:edit",
          parent_code: "Resource:Videoresources",
        });
      } else if (this.indexState == 2 && this.isActive == "1") {
        // 详情
        this.$children[0].Buriedpoint({
          code: "Resource:Videoresources:detail",
          parent_code: "Resource:Videoresources",
        });
      }
      this.isActive = index;
    },
  },
};
</script>